import { useEffect } from 'react';

import { useBootstrap, useFeatures } from '../../../controllers/store';
import { useDropdownActions } from '../../../controllers/store/dropdown';
import { useLogException } from '../../error-boundary';
import { prefetchRecentSearchResults } from '../fetch-recent-search-results';
import { prefetchRecentViewsResults } from '../fetch-recent-views-results';

export const useDropdownPrefetch = (): void => {
	const [{ user, primaryProduct, cloudId }] = useBootstrap();
	const { setPrefetchedRecentSearchResults, setPrefetchedRecentViewsResults } =
		useDropdownActions();
	const [features] = useFeatures();

	const logException = useLogException();

	useEffect(() => {
		async function fetchRecentViewsResults() {
			if (!cloudId) {
				return;
			}

			const recentViewsResults = await prefetchRecentViewsResults(cloudId, logException);
			setPrefetchedRecentViewsResults(recentViewsResults);
		}
		if (features?.recentViews?.enabled) {
			fetchRecentViewsResults();
		} else {
			setPrefetchedRecentViewsResults([]);
		}
	}, [setPrefetchedRecentViewsResults, cloudId, logException, features?.recentViews?.enabled]);

	useEffect(() => {
		if (features?.recentSearches?.enabled) {
			setPrefetchedRecentSearchResults(prefetchRecentSearchResults(primaryProduct, user?.id));
		} else {
			setPrefetchedRecentSearchResults([]);
		}
	}, [primaryProduct, user, setPrefetchedRecentSearchResults, features?.recentSearches?.enabled]);
};
